export interface IServiceAdminUserPageAccessRights {
    OfferMenu: string
    RequestASpotRate: string
    Marketplace: string
    Booking: string
    SearchAvailabilityAndPrice: string
    SearchAvailableSpace: string
    SearchAirWaybillStock: string
    CreateModifyBookingNew: string
    CreateModifyBookingOld: string
    CreateMultipleBookings: string
    CreateModifyBookingTemplates: string
    CreateRecurringBookingTemplate: string
    CreateSpreadsheetBookings: string
    CreateAirWaybillStockRequest: string
    CreateAllotmentRequest: string
    ViewAllotmentStatus: string
    ViewRateEstimate: string
    ViewCarrierSchedules: string
    Efreight: string
    CreateRetrieveMAWB: string
    RetrieveeDocs: string
    CreateModifyHAWB: string
    CreateModifyHAWBTemplates: string
    CreateModifyPieceIDInfo: string
    ManageShipments: string
    TrackShipments: string
    SearchAirWaybills: string
    ViewModifyBooking: string
    ReviewActiveQueuedBookings: string
    PrintBarcodeShippingLabel: string
    PrintShipperLetterOfInstruction: string
    MakeOnlinePayments: string
    ViewFlightStatus: string
    ViewCustomsStatus: string
    ViewArchivedAirWaybill: string
    ShipmentStatusbyEmail: string
    ReviewSpecializedBooking: string
    ShipmentReleaseDeclaration: string
    Edocs: string
    MyBookingDocuments: string
    AirWaybillDocumnets: string
    Efinance: string
    ViewInvoices: string
    ViewPaymentDetails: string
    eClaims: string
    CreateModifyPreliminaryClaim: string
    CreateModifyFinalClaim: string
    ViewACClaimStatus: string
    ViewAIClaimStatus: string
    ViewMHClaimStatus: string
    ViewSKClaimStatus: string
}

export interface IServiceAdminUserAuthorizationConfig {
    isBranchMemberStatus: boolean
    isBranchAdministratorStatus: boolean
    isCoLoaderStatus: boolean
    isBookingAuthorization: boolean
    isRateAuthorization: boolean
    isAllocationAuthorization: boolean
}

const ServiceAdminUserProfileConfig = () => {
    const serviceAdminUserConfigKey1: IServiceAdminUserAuthorizationConfig = {
        isBranchMemberStatus: true,
        isBranchAdministratorStatus: true,
        isCoLoaderStatus: false,
        isBookingAuthorization: true,
        isRateAuthorization: true,
        isAllocationAuthorization: true
    }

    const serviceAdminUserConfigValue1: IServiceAdminUserPageAccessRights = {
        OfferMenu: 'Y',
        RequestASpotRate: 'Y',
        Marketplace: 'Y',
        Booking: 'Y',
        SearchAvailabilityAndPrice: 'Y',
        SearchAvailableSpace: 'Y',
        SearchAirWaybillStock: 'Y',
        CreateModifyBookingNew: 'Y',
        CreateModifyBookingOld: 'Y',
        CreateMultipleBookings: 'Y',
        CreateModifyBookingTemplates: 'Y',
        CreateRecurringBookingTemplate: 'Y',
        CreateSpreadsheetBookings: 'Y',
        CreateAirWaybillStockRequest: 'Y',
        CreateAllotmentRequest: 'Y',
        ViewAllotmentStatus: 'Y',
        ViewRateEstimate: 'Y',
        ViewCarrierSchedules: 'Y',
        Efreight: 'Y',
        CreateRetrieveMAWB: 'Y',
        RetrieveeDocs: 'Y',
        CreateModifyHAWB: 'Y',
        CreateModifyHAWBTemplates: 'Y',
        CreateModifyPieceIDInfo: 'Y',
        ManageShipments: 'Y',
        TrackShipments: 'Y',
        SearchAirWaybills: 'Y',
        ViewModifyBooking: 'Y',
        ReviewActiveQueuedBookings: 'Y',
        PrintBarcodeShippingLabel: 'Y',
        PrintShipperLetterOfInstruction: 'Y',
        MakeOnlinePayments: 'Y',
        ViewFlightStatus: 'Y',
        ViewCustomsStatus: 'Y',
        ViewArchivedAirWaybill: 'Y',
        ShipmentStatusbyEmail: 'Y',
        ReviewSpecializedBooking: 'Y',
        ShipmentReleaseDeclaration: 'Y',
        Edocs: 'Y',
        MyBookingDocuments: 'Y',
        AirWaybillDocumnets: 'Y',
        Efinance: 'Y',
        ViewInvoices: 'Y',
        ViewPaymentDetails: 'Y',
        eClaims: 'Y',
        CreateModifyPreliminaryClaim: 'Y',
        CreateModifyFinalClaim: 'Y',
        ViewACClaimStatus: 'Y',
        ViewAIClaimStatus: 'Y',
        ViewMHClaimStatus: 'Y',
        ViewSKClaimStatus: 'Y'
    }

    // Create more ServiceAdminUserAuthorizationConfig instances for other configurations

    const serviceAdminUserConfigKey2: IServiceAdminUserAuthorizationConfig = {
        isBranchMemberStatus: true,
        isBranchAdministratorStatus: true,
        isCoLoaderStatus: false,
        isBookingAuthorization: false,
        isRateAuthorization: true,
        isAllocationAuthorization: true
    }

    const serviceAdminUserConfigValue2: IServiceAdminUserPageAccessRights = {
        OfferMenu: 'Y',
        RequestASpotRate: 'Y',
        Marketplace: 'Y',
        Booking: 'Y',
        SearchAvailabilityAndPrice: 'Y',
        SearchAvailableSpace: 'Y',
        SearchAirWaybillStock: 'N',
        CreateModifyBookingNew: 'N',
        CreateModifyBookingOld: 'N',
        CreateMultipleBookings: 'N',
        CreateModifyBookingTemplates: 'N',
        CreateRecurringBookingTemplate: 'N',
        CreateSpreadsheetBookings: 'N',
        CreateAirWaybillStockRequest: 'N',
        CreateAllotmentRequest: 'Y',
        ViewAllotmentStatus: 'Y',
        ViewRateEstimate: 'Y',
        ViewCarrierSchedules: 'Y',
        Efreight: 'Y',
        CreateRetrieveMAWB: 'Y',
        RetrieveeDocs: 'Y',
        CreateModifyHAWB: 'Y',
        CreateModifyHAWBTemplates: 'Y',
        CreateModifyPieceIDInfo: 'Y',
        ManageShipments: 'Y',
        TrackShipments: 'Y',
        SearchAirWaybills: 'Y',
        ViewModifyBooking: 'N',
        ReviewActiveQueuedBookings: 'N',
        PrintBarcodeShippingLabel: 'N',
        PrintShipperLetterOfInstruction: 'N',
        MakeOnlinePayments: 'N',
        ViewFlightStatus: 'Y',
        ViewCustomsStatus: 'Y',
        ViewArchivedAirWaybill: 'Y',
        ShipmentStatusbyEmail: 'Y',
        ReviewSpecializedBooking: 'N',
        ShipmentReleaseDeclaration: 'Y',
        Edocs: 'Y',
        MyBookingDocuments: 'Y',
        AirWaybillDocumnets: 'Y',
        Efinance: 'Y',
        ViewInvoices: 'Y',
        ViewPaymentDetails: 'Y',
        eClaims: 'Y',
        CreateModifyPreliminaryClaim: 'Y',
        CreateModifyFinalClaim: 'Y',
        ViewACClaimStatus: 'Y',
        ViewAIClaimStatus: 'Y',
        ViewMHClaimStatus: 'Y',
        ViewSKClaimStatus: 'Y'
    }

    const serviceAdminUserConfigKey3: IServiceAdminUserAuthorizationConfig = {
        isBranchMemberStatus: true,
        isBranchAdministratorStatus: true,
        isCoLoaderStatus: false,
        isBookingAuthorization: true,
        isRateAuthorization: false,
        isAllocationAuthorization: true
    }

    const serviceAdminUserConfigValue3: IServiceAdminUserPageAccessRights = {
        OfferMenu: 'Y',
        RequestASpotRate: 'Y',
        Marketplace: 'N',
        Booking: 'Y',
        SearchAvailabilityAndPrice: 'N',
        SearchAvailableSpace: 'Y',
        SearchAirWaybillStock: 'Y',
        CreateModifyBookingNew: 'Y',
        CreateModifyBookingOld: 'Y',
        CreateMultipleBookings: 'Y',
        CreateModifyBookingTemplates: 'Y',
        CreateRecurringBookingTemplate: 'Y',
        CreateSpreadsheetBookings: 'Y',
        CreateAirWaybillStockRequest: 'Y',
        CreateAllotmentRequest: 'Y',
        ViewAllotmentStatus: 'Y',
        ViewRateEstimate: 'N',
        ViewCarrierSchedules: 'Y',
        Efreight: 'Y',
        CreateRetrieveMAWB: 'Y',
        RetrieveeDocs: 'Y',
        CreateModifyHAWB: 'Y',
        CreateModifyHAWBTemplates: 'Y',
        CreateModifyPieceIDInfo: 'Y',
        ManageShipments: 'Y',
        TrackShipments: 'Y',
        SearchAirWaybills: 'Y',
        ViewModifyBooking: 'Y',
        ReviewActiveQueuedBookings: 'Y',
        PrintBarcodeShippingLabel: 'Y',
        PrintShipperLetterOfInstruction: 'Y',
        MakeOnlinePayments: 'Y',
        ViewFlightStatus: 'Y',
        ViewCustomsStatus: 'Y',
        ViewArchivedAirWaybill: 'Y',
        ShipmentStatusbyEmail: 'Y',
        ReviewSpecializedBooking: 'Y',
        ShipmentReleaseDeclaration: 'Y',
        Edocs: 'Y',
        MyBookingDocuments: 'Y',
        AirWaybillDocumnets: 'Y',
        Efinance: 'Y',
        ViewInvoices: 'Y',
        ViewPaymentDetails: 'Y',
        eClaims: 'Y',
        CreateModifyPreliminaryClaim: 'Y',
        CreateModifyFinalClaim: 'Y',
        ViewACClaimStatus: 'Y',
        ViewAIClaimStatus: 'Y',
        ViewMHClaimStatus: 'Y',
        ViewSKClaimStatus: 'Y'
    }

    const serviceAdminUserConfigKey4: IServiceAdminUserAuthorizationConfig = {
        isBranchMemberStatus: true,
        isBranchAdministratorStatus: true,
        isCoLoaderStatus: false,
        isBookingAuthorization: true,
        isRateAuthorization: true,
        isAllocationAuthorization: false
    }

    const serviceAdminUserConfigValue4: IServiceAdminUserPageAccessRights = {
        OfferMenu: 'Y',
        RequestASpotRate: 'Y',
        Marketplace: 'Y',
        Booking: 'Y',
        SearchAvailabilityAndPrice: 'Y',
        SearchAvailableSpace: 'Y',
        SearchAirWaybillStock: 'Y',
        CreateModifyBookingNew: 'Y',
        CreateModifyBookingOld: 'Y',
        CreateMultipleBookings: 'Y',
        CreateModifyBookingTemplates: 'Y',
        CreateRecurringBookingTemplate: 'Y',
        CreateSpreadsheetBookings: 'Y',
        CreateAirWaybillStockRequest: 'Y',
        CreateAllotmentRequest: 'N',
        ViewAllotmentStatus: 'N',
        ViewRateEstimate: 'Y',
        ViewCarrierSchedules: 'Y',
        Efreight: 'Y',
        CreateRetrieveMAWB: 'Y',
        RetrieveeDocs: 'Y',
        CreateModifyHAWB: 'Y',
        CreateModifyHAWBTemplates: 'Y',
        CreateModifyPieceIDInfo: 'Y',
        ManageShipments: 'Y',
        TrackShipments: 'Y',
        SearchAirWaybills: 'Y',
        ViewModifyBooking: 'Y',
        ReviewActiveQueuedBookings: 'Y',
        PrintBarcodeShippingLabel: 'Y',
        PrintShipperLetterOfInstruction: 'Y',
        MakeOnlinePayments: 'Y',
        ViewFlightStatus: 'Y',
        ViewCustomsStatus: 'Y',
        ViewArchivedAirWaybill: 'Y',
        ShipmentStatusbyEmail: 'Y',
        ReviewSpecializedBooking: 'Y',
        ShipmentReleaseDeclaration: 'Y',
        Edocs: 'Y',
        MyBookingDocuments: 'Y',
        AirWaybillDocumnets: 'Y',
        Efinance: 'Y',
        ViewInvoices: 'Y',
        ViewPaymentDetails: 'Y',
        eClaims: 'Y',
        CreateModifyPreliminaryClaim: 'Y',
        CreateModifyFinalClaim: 'Y',
        ViewACClaimStatus: 'Y',
        ViewAIClaimStatus: 'Y',
        ViewMHClaimStatus: 'Y',
        ViewSKClaimStatus: 'Y'
    }

    const serviceAdminUserConfigKey5: IServiceAdminUserAuthorizationConfig = {
        isBranchMemberStatus: true,
        isBranchAdministratorStatus: true,
        isCoLoaderStatus: false,
        isBookingAuthorization: false,
        isRateAuthorization: false,
        isAllocationAuthorization: false
    }

    const serviceAdminUserConfigValue5: IServiceAdminUserPageAccessRights = {
        OfferMenu: 'Y',
        RequestASpotRate: 'Y',
        Marketplace: 'N',
        Booking: 'Y',
        SearchAvailabilityAndPrice: 'N',
        SearchAvailableSpace: 'Y',
        SearchAirWaybillStock: 'N',
        CreateModifyBookingNew: 'N',
        CreateModifyBookingOld: 'N',
        CreateMultipleBookings: 'N',
        CreateModifyBookingTemplates: 'N',
        CreateRecurringBookingTemplate: 'N',
        CreateSpreadsheetBookings: 'N',
        CreateAirWaybillStockRequest: 'N',
        CreateAllotmentRequest: 'N',
        ViewAllotmentStatus: 'N',
        ViewRateEstimate: 'N',
        ViewCarrierSchedules: 'Y',
        Efreight: 'Y',
        CreateRetrieveMAWB: 'Y',
        RetrieveeDocs: 'Y',
        CreateModifyHAWB: 'Y',
        CreateModifyHAWBTemplates: 'Y',
        CreateModifyPieceIDInfo: 'Y',
        ManageShipments: 'Y',
        TrackShipments: 'Y',
        SearchAirWaybills: 'Y',
        ViewModifyBooking: 'N',
        ReviewActiveQueuedBookings: 'N',
        PrintBarcodeShippingLabel: 'N',
        PrintShipperLetterOfInstruction: 'N',
        MakeOnlinePayments: 'N',
        ViewFlightStatus: 'Y',
        ViewCustomsStatus: 'Y',
        ViewArchivedAirWaybill: 'Y',
        ShipmentStatusbyEmail: 'Y',
        ReviewSpecializedBooking: 'N',
        ShipmentReleaseDeclaration: 'Y',
        Edocs: 'Y',
        MyBookingDocuments: 'Y',
        AirWaybillDocumnets: 'Y',
        Efinance: 'Y',
        ViewInvoices: 'Y',
        ViewPaymentDetails: 'Y',
        eClaims: 'Y',
        CreateModifyPreliminaryClaim: 'Y',
        CreateModifyFinalClaim: 'Y',
        ViewACClaimStatus: 'Y',
        ViewAIClaimStatus: 'Y',
        ViewMHClaimStatus: 'Y',
        ViewSKClaimStatus: 'Y'
    }

    const serviceAdminUserConfigKey6: IServiceAdminUserAuthorizationConfig = {
        isBranchMemberStatus: true,
        isBranchAdministratorStatus: false,
        isCoLoaderStatus: false,
        isBookingAuthorization: true,
        isRateAuthorization: true,
        isAllocationAuthorization: true
    }

    const serviceAdminUserConfigValue6: IServiceAdminUserPageAccessRights = {
        OfferMenu: 'Y',
        RequestASpotRate: 'Y',
        Marketplace: 'Y',
        Booking: 'Y',
        SearchAvailabilityAndPrice: 'Y',
        SearchAvailableSpace: 'Y',
        SearchAirWaybillStock: 'Y',
        CreateModifyBookingNew: 'Y',
        CreateModifyBookingOld: 'Y',
        CreateMultipleBookings: 'Y',
        CreateModifyBookingTemplates: 'Y',
        CreateRecurringBookingTemplate: 'Y',
        CreateSpreadsheetBookings: 'Y',
        CreateAirWaybillStockRequest: 'Y',
        CreateAllotmentRequest: 'Y',
        ViewAllotmentStatus: 'Y',
        ViewRateEstimate: 'Y',
        ViewCarrierSchedules: 'Y',
        Efreight: 'Y',
        CreateRetrieveMAWB: 'Y',
        RetrieveeDocs: 'Y',
        CreateModifyHAWB: 'Y',
        CreateModifyHAWBTemplates: 'Y',
        CreateModifyPieceIDInfo: 'Y',
        ManageShipments: 'Y',
        TrackShipments: 'Y',
        SearchAirWaybills: 'Y',
        ViewModifyBooking: 'Y',
        ReviewActiveQueuedBookings: 'Y',
        PrintBarcodeShippingLabel: 'Y',
        PrintShipperLetterOfInstruction: 'Y',
        MakeOnlinePayments: 'Y',
        ViewFlightStatus: 'Y',
        ViewCustomsStatus: 'Y',
        ViewArchivedAirWaybill: 'Y',
        ShipmentStatusbyEmail: 'Y',
        ReviewSpecializedBooking: 'Y',
        ShipmentReleaseDeclaration: 'Y',
        Edocs: 'Y',
        MyBookingDocuments: 'Y',
        AirWaybillDocumnets: 'Y',
        Efinance: 'Y',
        ViewInvoices: 'Y',
        ViewPaymentDetails: 'Y',
        eClaims: 'Y',
        CreateModifyPreliminaryClaim: 'Y',
        CreateModifyFinalClaim: 'Y',
        ViewACClaimStatus: 'Y',
        ViewAIClaimStatus: 'Y',
        ViewMHClaimStatus: 'Y',
        ViewSKClaimStatus: 'Y'
    }

    const serviceAdminUserConfigKey7: IServiceAdminUserAuthorizationConfig = {
        isBranchMemberStatus: false,
        isBranchAdministratorStatus: true,
        isCoLoaderStatus: false,
        isBookingAuthorization: true,
        isRateAuthorization: true,
        isAllocationAuthorization: true
    }

    const serviceAdminUserConfigValue7: IServiceAdminUserPageAccessRights = {
        OfferMenu: 'Y',
        RequestASpotRate: 'N',
        Marketplace: 'N',
        Booking: 'Y',
        SearchAvailabilityAndPrice: 'N',
        SearchAvailableSpace: 'N',
        SearchAirWaybillStock: 'N',
        CreateModifyBookingNew: 'N',
        CreateModifyBookingOld: 'N',
        CreateMultipleBookings: 'N',
        CreateModifyBookingTemplates: 'N',
        CreateRecurringBookingTemplate: 'N',
        CreateSpreadsheetBookings: 'N',
        CreateAirWaybillStockRequest: 'N',
        CreateAllotmentRequest: 'N',
        ViewAllotmentStatus: 'N',
        ViewRateEstimate: 'N',
        ViewCarrierSchedules: 'N',
        Efreight: 'Y',
        CreateRetrieveMAWB: 'N',
        RetrieveeDocs: 'N',
        CreateModifyHAWB: 'N',
        CreateModifyHAWBTemplates: 'N',
        CreateModifyPieceIDInfo: 'N',
        ManageShipments: 'Y',
        TrackShipments: 'N',
        SearchAirWaybills: 'N',
        ViewModifyBooking: 'N',
        ReviewActiveQueuedBookings: 'N',
        PrintBarcodeShippingLabel: 'N',
        PrintShipperLetterOfInstruction: 'N',
        MakeOnlinePayments: 'N',
        ViewFlightStatus: 'N',
        ViewCustomsStatus: 'N',
        ViewArchivedAirWaybill: 'N',
        ShipmentStatusbyEmail: 'N',
        ReviewSpecializedBooking: 'N',
        ShipmentReleaseDeclaration: 'N',
        Edocs: 'Y',
        MyBookingDocuments: 'N',
        AirWaybillDocumnets: 'N',
        Efinance: 'Y',
        ViewInvoices: 'N',
        ViewPaymentDetails: 'N',
        eClaims: 'Y',
        CreateModifyPreliminaryClaim: 'N',
        CreateModifyFinalClaim: 'N',
        ViewACClaimStatus: 'N',
        ViewAIClaimStatus: 'N',
        ViewMHClaimStatus: 'N',
        ViewSKClaimStatus: 'N'
    }

    const serviceAdminUserConfigKey8: IServiceAdminUserAuthorizationConfig = {
        isBranchMemberStatus: false,
        isBranchAdministratorStatus: false,
        isCoLoaderStatus: false,
        isBookingAuthorization: true,
        isRateAuthorization: true,
        isAllocationAuthorization: true
    }

    const serviceAdminUserConfigValue8: IServiceAdminUserPageAccessRights = {
        OfferMenu: 'Y',
        RequestASpotRate: 'N',
        Marketplace: 'N',
        Booking: 'Y',
        SearchAvailabilityAndPrice: 'N',
        SearchAvailableSpace: 'N',
        SearchAirWaybillStock: 'N',
        CreateModifyBookingNew: 'N',
        CreateModifyBookingOld: 'N',
        CreateMultipleBookings: 'N',
        CreateModifyBookingTemplates: 'N',
        CreateRecurringBookingTemplate: 'N',
        CreateSpreadsheetBookings: 'N',
        CreateAirWaybillStockRequest: 'N',
        CreateAllotmentRequest: 'N',
        ViewAllotmentStatus: 'N',
        ViewRateEstimate: 'N',
        ViewCarrierSchedules: 'N',
        Efreight: 'Y',
        CreateRetrieveMAWB: 'N',
        RetrieveeDocs: 'N',
        CreateModifyHAWB: 'N',
        CreateModifyHAWBTemplates: 'N',
        CreateModifyPieceIDInfo: 'N',
        ManageShipments: 'Y',
        TrackShipments: 'N',
        SearchAirWaybills: 'N',
        ViewModifyBooking: 'N',
        ReviewActiveQueuedBookings: 'N',
        PrintBarcodeShippingLabel: 'N',
        PrintShipperLetterOfInstruction: 'N',
        MakeOnlinePayments: 'N',
        ViewFlightStatus: 'N',
        ViewCustomsStatus: 'N',
        ViewArchivedAirWaybill: 'N',
        ShipmentStatusbyEmail: 'N',
        ReviewSpecializedBooking: 'N',
        ShipmentReleaseDeclaration: 'N',
        Edocs: 'Y',
        MyBookingDocuments: 'N',
        AirWaybillDocumnets: 'N',
        Efinance: 'Y',
        ViewInvoices: 'N',
        ViewPaymentDetails: 'N',
        eClaims: 'Y',
        CreateModifyPreliminaryClaim: 'N',
        CreateModifyFinalClaim: 'N',
        ViewACClaimStatus: 'N',
        ViewAIClaimStatus: 'N',
        ViewMHClaimStatus: 'N',
        ViewSKClaimStatus: 'N'
    }

    const serviceAdminUserConfigKey9: IServiceAdminUserAuthorizationConfig = {
        isBranchMemberStatus: true,
        isBranchAdministratorStatus: false,
        isCoLoaderStatus: true,
        isBookingAuthorization: true,
        isRateAuthorization: true,
        isAllocationAuthorization: true
    }

    const serviceAdminUserConfigValue9: IServiceAdminUserPageAccessRights = {
        OfferMenu: 'Y',
        RequestASpotRate: 'N',
        Marketplace: 'N',
        Booking: 'Y',
        SearchAvailabilityAndPrice: 'N',
        SearchAvailableSpace: 'N',
        SearchAirWaybillStock: 'N',
        CreateModifyBookingNew: 'N',
        CreateModifyBookingOld: 'N',
        CreateMultipleBookings: 'N',
        CreateModifyBookingTemplates: 'N',
        CreateRecurringBookingTemplate: 'N',
        CreateSpreadsheetBookings: 'N',
        CreateAirWaybillStockRequest: 'N',
        CreateAllotmentRequest: 'N',
        ViewAllotmentStatus: 'N',
        ViewRateEstimate: 'N',
        ViewCarrierSchedules: 'Y',
        Efreight: 'Y',
        CreateRetrieveMAWB: 'N',
        RetrieveeDocs: 'N',
        CreateModifyHAWB: 'N',
        CreateModifyHAWBTemplates: 'N',
        CreateModifyPieceIDInfo: 'N',
        ManageShipments: 'Y',
        TrackShipments: 'Y',
        SearchAirWaybills: 'N',
        ViewModifyBooking: 'N',
        ReviewActiveQueuedBookings: 'N',
        PrintBarcodeShippingLabel: 'Y',
        PrintShipperLetterOfInstruction: 'Y',
        MakeOnlinePayments: 'N',
        ViewFlightStatus: 'Y',
        ViewCustomsStatus: 'N',
        ViewArchivedAirWaybill: 'N',
        ShipmentStatusbyEmail: 'N',
        ReviewSpecializedBooking: 'N',
        ShipmentReleaseDeclaration: 'Y',
        Edocs: 'Y',
        MyBookingDocuments: 'N',
        AirWaybillDocumnets: 'N',
        Efinance: 'Y',
        ViewInvoices: 'N',
        ViewPaymentDetails: 'N',
        eClaims: 'Y',
        CreateModifyPreliminaryClaim: 'N',
        CreateModifyFinalClaim: 'N',
        ViewACClaimStatus: 'N',
        ViewAIClaimStatus: 'N',
        ViewMHClaimStatus: 'N',
        ViewSKClaimStatus: 'N'
    }

    const serviceAdminUserConfigKey10: IServiceAdminUserAuthorizationConfig = {
        isBranchMemberStatus: true,
        isBranchAdministratorStatus: false,
        isCoLoaderStatus: true,
        isBookingAuthorization: false,
        isRateAuthorization: false,
        isAllocationAuthorization: false
    }

    const serviceAdminUserConfigValue10: IServiceAdminUserPageAccessRights = {
        OfferMenu: 'Y',
        RequestASpotRate: 'N',
        Marketplace: 'N',
        Booking: 'Y',
        SearchAvailabilityAndPrice: 'N',
        SearchAvailableSpace: 'N',
        SearchAirWaybillStock: 'N',
        CreateModifyBookingNew: 'N',
        CreateModifyBookingOld: 'N',
        CreateMultipleBookings: 'N',
        CreateModifyBookingTemplates: 'N',
        CreateRecurringBookingTemplate: 'N',
        CreateSpreadsheetBookings: 'N',
        CreateAirWaybillStockRequest: 'N',
        CreateAllotmentRequest: 'N',
        ViewAllotmentStatus: 'N',
        ViewRateEstimate: 'N',
        ViewCarrierSchedules: 'Y',
        Efreight: 'Y',
        CreateRetrieveMAWB: 'N',
        RetrieveeDocs: 'N',
        CreateModifyHAWB: 'N',
        CreateModifyHAWBTemplates: 'N',
        CreateModifyPieceIDInfo: 'N',
        ManageShipments: 'Y',
        TrackShipments: 'Y',
        SearchAirWaybills: 'N',
        ViewModifyBooking: 'N',
        ReviewActiveQueuedBookings: 'N',
        PrintBarcodeShippingLabel: 'Y',
        PrintShipperLetterOfInstruction: 'Y',
        MakeOnlinePayments: 'N',
        ViewFlightStatus: 'Y',
        ViewCustomsStatus: 'N',
        ViewArchivedAirWaybill: 'N',
        ShipmentStatusbyEmail: 'N',
        ReviewSpecializedBooking: 'N',
        ShipmentReleaseDeclaration: 'Y',
        Edocs: 'Y',
        MyBookingDocuments: 'N',
        AirWaybillDocumnets: 'N',
        Efinance: 'Y',
        ViewInvoices: 'N',
        ViewPaymentDetails: 'N',
        eClaims: 'Y',
        CreateModifyPreliminaryClaim: 'N',
        CreateModifyFinalClaim: 'N',
        ViewACClaimStatus: 'N',
        ViewAIClaimStatus: 'N',
        ViewMHClaimStatus: 'N',
        ViewSKClaimStatus: 'N'
    }

    const serviceAdminUserConfigKey11: IServiceAdminUserAuthorizationConfig = {
        isBranchMemberStatus: false,
        isBranchAdministratorStatus: false,
        isCoLoaderStatus: true,
        isBookingAuthorization: false,
        isRateAuthorization: false,
        isAllocationAuthorization: false
    }

    const serviceAdminUserConfigValue11: IServiceAdminUserPageAccessRights = {
        OfferMenu: 'Y',
        RequestASpotRate: 'N',
        Marketplace: 'N',
        Booking: 'Y',
        SearchAvailabilityAndPrice: 'N',
        SearchAvailableSpace: 'N',
        SearchAirWaybillStock: 'N',
        CreateModifyBookingNew: 'N',
        CreateModifyBookingOld: 'N',
        CreateMultipleBookings: 'N',
        CreateModifyBookingTemplates: 'N',
        CreateRecurringBookingTemplate: 'N',
        CreateSpreadsheetBookings: 'N',
        CreateAirWaybillStockRequest: 'N',
        CreateAllotmentRequest: 'N',
        ViewAllotmentStatus: 'N',
        ViewRateEstimate: 'N',
        ViewCarrierSchedules: 'Y',
        Efreight: 'Y',
        CreateRetrieveMAWB: 'N',
        RetrieveeDocs: 'N',
        CreateModifyHAWB: 'N',
        CreateModifyHAWBTemplates: 'N',
        CreateModifyPieceIDInfo: 'N',
        ManageShipments: 'Y',
        TrackShipments: 'Y',
        SearchAirWaybills: 'N',
        ViewModifyBooking: 'N',
        ReviewActiveQueuedBookings: 'N',
        PrintBarcodeShippingLabel: 'Y',
        PrintShipperLetterOfInstruction: 'Y',
        MakeOnlinePayments: 'N',
        ViewFlightStatus: 'Y',
        ViewCustomsStatus: 'N',
        ViewArchivedAirWaybill: 'N',
        ShipmentStatusbyEmail: 'N',
        ReviewSpecializedBooking: 'N',
        ShipmentReleaseDeclaration: 'Y',
        Edocs: 'Y',
        MyBookingDocuments: 'N',
        AirWaybillDocumnets: 'N',
        Efinance: 'Y',
        ViewInvoices: 'N',
        ViewPaymentDetails: 'N',
        eClaims: 'Y',
        CreateModifyPreliminaryClaim: 'N',
        CreateModifyFinalClaim: 'N',
        ViewACClaimStatus: 'N',
        ViewAIClaimStatus: 'N',
        ViewMHClaimStatus: 'N',
        ViewSKClaimStatus: 'N'
    }

    const adminHashMap = new Map<IServiceAdminUserAuthorizationConfig, IServiceAdminUserPageAccessRights>()
    adminHashMap.set(serviceAdminUserConfigKey1, serviceAdminUserConfigValue1)
    adminHashMap.set(serviceAdminUserConfigKey2, serviceAdminUserConfigValue2)
    adminHashMap.set(serviceAdminUserConfigKey3, serviceAdminUserConfigValue3)
    adminHashMap.set(serviceAdminUserConfigKey4, serviceAdminUserConfigValue4)
    adminHashMap.set(serviceAdminUserConfigKey5, serviceAdminUserConfigValue5)
    adminHashMap.set(serviceAdminUserConfigKey6, serviceAdminUserConfigValue6)
    adminHashMap.set(serviceAdminUserConfigKey7, serviceAdminUserConfigValue7)
    adminHashMap.set(serviceAdminUserConfigKey8, serviceAdminUserConfigValue8)
    adminHashMap.set(serviceAdminUserConfigKey9, serviceAdminUserConfigValue9)
    adminHashMap.set(serviceAdminUserConfigKey10, serviceAdminUserConfigValue10)
    adminHashMap.set(serviceAdminUserConfigKey11, serviceAdminUserConfigValue11)

    return adminHashMap
}
export default ServiceAdminUserProfileConfig
